module.exports = __webpack_public_path__ + "img/glasses-1.c4b429ea.svg";